export const set = (key, val) => {
  window.localStorage.setItem(key, JSON.stringify(val));
};

export const get = (key) => window.localStorage && window.localStorage.getItem(key) ? JSON.parse(window.localStorage.getItem(key)) : undefined;

export const setOidc = (oidc) => set("oidc", oidc);
export const getOidc = () => get("oidc");
export const deleteAll = () => window.localStorage.clear();
export const remove = (key) => window.localStorage.removeItem(key);

export const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  } 
  try {
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }
  catch (err) {
    if (itemStr !== null) {
      setWithExpiry(key, itemStr);
    }
    return itemStr;
  }

};

export const setWithExpiry = (key, value, ttlInDays = 30) => {

  const ttlInMilliseconds = ttlInDays * 24 * 60 * 60 * 1000; // days in milliseconds
  const now = new Date()
	const item = {
		value: value,
		expiry: now.getTime() + ttlInMilliseconds,
	}
	localStorage.setItem(key, JSON.stringify(item))
};
